import {
    useMutation,
    useQueryClient
} from "react-query";

import { CreateTagInput } from "../../../API";
import { graphQLTagDAO } from "../dao/GraphQLTagDAO";
import { useMemo } from "react";

export const useCreateTag = (propertyId: string) => {
    const queryClient = useQueryClient();
    const queryKey = useMemo(() => ["tags", propertyId], [propertyId]);

    const createTagMutation = useMutation({
        mutationFn: async (tag: CreateTagInput) => {
            return await graphQLTagDAO.create(tag);
        },
        onMutate: async (tag: CreateTagInput) => {
            await queryClient.cancelQueries(queryKey);
            const previousTags = queryClient.getQueryData(queryKey);
            queryClient.setQueryData(queryKey, (old: any) => [...old, tag]);
            return { previousTags };
        },
        onError: (error, tag, context: any) => {
            if (context?.previousTags) {
                queryClient.setQueryData(queryKey, context.previousTags);
            }
        },
        onSettled: () => {
            queryClient.invalidateQueries(queryKey);
        }
    });

    return { createTagMutation };
};